import type { ChargebackStatus, ChargebackTier } from "@/types/chargeback";

export const chargebackStatusVariants: Record<
  ChargebackStatus,
  "default" | "neutral" | "success" | "error" | "warning" | "dark"
> = {
  INQUIRY_ACTION_REQUIRED: "warning",
  INQUIRY_RESPONDED: "default",
  INQUIRY_PROCESSING: "default",
  DISPUTE_ACTION_REQUIRED: "error",
  CHARGEBACK_PROCESSING: "default",
  PRE_ARBITRATION_PROCESSING: "default",
  ARBITRATION: "default",
  PROVISIONAL_WIN: "success",
  WON: "success",
  LOST: "error",
  ACCEPTED: "neutral",
};

export const chargebackTierVariants: Record<
  ChargebackTier,
  "default" | "neutral" | "success" | "error" | "warning" | "dark"
> = {
  ACTION_REQUIRED: "error",
  IN_PROGRESS: "warning",
  FAVORABLE: "success",
  UNFAVORABLE: "neutral",
};

export const chargebackTierLabels: Record<ChargebackTier, string> = {
  ACTION_REQUIRED: "Action required",
  IN_PROGRESS: "Chargeback in progress",
  FAVORABLE: "Chargeback won",
  UNFAVORABLE: "Chargeback lost",
};
